<template>
	<modal
		:class="`ui ui--search ${name}`"
		:search-scope="`${scope}`"
		:search-outdated="scopeState.outdated"
		:search-input-expanded="inputExpanded"
	>
		<!-- <h1 element-translation="found" class="element element--headline element--headline--big">Search</h1> -->

		<ElementInputtext
			ref="queryInput"
			name="Enter Search"
			type="text"
			inputmode="latin"
			pattern="String"
			placeholder="Suchbegriff"
			maxlength="100"
			v-model="query"
			required
			clearable
			autoExpand
			:toggle="toggleInput"
		/>
		<ElementButton v-if="scopeState.options.closeButton === true" name="close" @click.stop="close" />
		<ElementList v-if="alteredSearchResults.length" :entries="alteredSearchResults" />
		<h3 v-if="!alteredSearchResults.length" class="search-empty">{{ $t('noEntriesFound') }}</h3>
		<ElementButton
			v-if="scopeState.resetFilter"
			name="resetfilter"
			content="reset filter"
			i18n
			@click.stop="resetFilter"
		/>
		<transition name="visible">
			<ElementButton
				ref="refresh"
				v-if="showRefreshButton"
				:data-result="areaCount"
				name="refresh"
				content="refresh"
				i18n
				@onAnimationEnd="refreshAnimationEnd()"
				@click.stop="refresh"
			/>
		</transition>
	</modal>
</template>

<style lang="sass"></style>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { actionTypes, mutationTypes } from '../../types';
import { mapStateNested, capitalizeFirstLetter } from '../../tools/helpers';
import UiBase from './base.vue';
import { uiComponents } from '../../tools/viewState';

export default {
	extends: UiBase,
	props: ['scope'],
	data() {
		return {
			name: uiComponents[`uiSearch${capitalizeFirstLetter(this.scope)}`],
			inputExpanded: false,
		};
	},
	computed: {
		...mapState(['areaBeaconAlgorithm', 'dataSourceURL']),
		...mapStateNested('areaBeaconAlgorithm', ['timestamp', 'areaCount']),
		...mapState({
			scopeState(state) {
				return state.search.scopes[this.scope];
			},
		}),
		alteredSearchResults() {
			return this.$store.getters[`${this.scope}AlteredSearchResults`];
		},
		query: {
			set(queryString) {
				this.searchQuery({ scope: this.scope, query: queryString });
			},
			get() {
				return this.scopeState.query;
			},
		},
		searchSetFocus() {
			return this.scopeState.options.setFocus;
		},
		currentDataCount() {
			//  current Datacount of the datasource of the search scope
			switch (this.scope) {
				case 'areabeacons':
					{
						return this.areaCount;
					}
					break;
				default:
					return 0;
			}
			return 0;
		},
		showRefreshButton() {
			switch (this.scope) {
				case 'areabeacons':
					{
						return this.timestamp !== null && this.timestamp !== this.scopeState.timestamp;
					}
					break;
				default:
					return this.scopeState.options.refresh;
			}
			return false;
		},
	},

	methods: {
		...mapMutations([mutationTypes.searchQuery]),
		...mapActions([actionTypes.searchRefresh]),
		refresh() {
			if (this.scopeState.refresh) {
				this.scopeState.refresh();
			}
		},
		resetFilter() {
			if (this.scopeState.reset) {
				this.scopeState.resetFilter();
			}
		},
		toggleInput() {
			this.inputExpanded = !this.inputExpanded;
		},
		dataCount() {},
		refreshAnimationEnd() {
			this.$refs.refresh.$el.classList.remove('updated');
		},
	},
	mounted() {
		this.inputExpanded = this.searchSetFocus;
	},
	updated() {
		// this.inputExpanded = this.searchSetFocus;
	},
	activated() {
		this.inputExpanded = this.searchSetFocus;
	},
	watch: {
		isOpen() {
			if (this.isOpen) {
				if (this.searchSetFocus) {
					this.inputExpanded = true;
				}
			}
		},
		areaCount() {
			if (this.$refs.refresh && !this.$refs.refresh.$el.classList.contains('updated')) {
				this.$refs.refresh.$el.classList.add('updated');
			}
		},
		alteredSearchResults() {
			// console.log('#search altered');
			// imageLoader.watch({
			// 	container: this.$el,
			// });
		},
	},
};
</script>
<style lang="css"></style>
